import * as React from 'react'

import { cn } from '@ui/lib/utils'
import { useFormField } from './form'

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

export const getTextareaClassName = (error: boolean, className?: string) => {
  return cn(
    `flex w-full rounded-m px-s py-xs text-base text-gray-900 outline outline-1 outline-gray-200 ring-offset-white transition-[outline,background-color] duration-200 ease-in-out placeholder:inherit placeholder:text-gray-400 placeholder:text-gray-500 hover:outline-2 hover:outline-gray-400 focus-visible:bg-gray-50 focus-visible:text-gray-900  focus-visible:outline-2 focus-visible:outline-blue-600 disabled:cursor-not-allowed disabled:select-none disabled:text-gray-300 disabled:outline-gray-200`,
    {
      'bg-red-50 outline-red-500': !!error,
    },
    className,
  )
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    const { error } = useFormField()

    return (
      <textarea
        className={getTextareaClassName(!!error, className)}
        ref={ref}
        {...props}
      />
    )
  },
)
Textarea.displayName = 'Textarea'

export { Textarea }
